import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/audio/banner-switch.ogg'
import _imports_1 from '@/assets/audio/banner-switch.mp3'
import _imports_2 from '@/assets/images/ui-wish-edited.webp'


const _withScopeId = n => (_pushScopeId("data-v-48a67e8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("audio", {
  id: "audio-banner-switch",
  preload: "auto"
}, [
  /*#__PURE__*/_createElementVNode("source", {
    src: _imports_0,
    type: "audio/ogg"
  }),
  /*#__PURE__*/_createElementVNode("source", {
    src: _imports_1,
    type: "audio/mp3"
  })
], -1))
const _hoisted_2 = { class: "banner-container" }
const _hoisted_3 = {
  key: 0,
  class: "mobile-header"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src", "onClick"]
const _hoisted_7 = {
  id: "wish-label",
  class: "space-between center"
}
const _hoisted_8 = {
  key: 0,
  src: _imports_2
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { id: "wish-label" }, "Wish", -1))
const _hoisted_10 = {
  key: 0,
  class: "banner-header"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src", "onClick"]
const _hoisted_13 = { id: "gems" }
const _hoisted_14 = { class: "close-box" }
const _hoisted_15 = {
  key: 0,
  class: "everyone"
}
const _hoisted_16 = ["src"]
const _hoisted_17 = { id: "shop-button-holder-sometimes" }
const _hoisted_18 = {
  key: 0,
  id: "masterless-home",
  class: "footer-align-flex left-align-flex"
}
const _hoisted_19 = {
  id: "shop-buttons",
  class: "footer-align-flex"
}
const _hoisted_20 = {
  id: "wish-buttons",
  class: "footer-align-flex"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_item_description_overlay = _resolveComponent("item-description-overlay")!
  const _component_banner_details_screen = _resolveComponent("banner-details-screen")!
  const _component_wish_history_screen = _resolveComponent("wish-history-screen")!
  const _component_settings_screen = _resolveComponent("settings-screen")!
  const _component_gem_counter = _resolveComponent("gem-counter")!
  const _component_close_button = _resolveComponent("close-button")!
  const _component_text_button = _resolveComponent("text-button")!
  const _component_wish_button = _resolveComponent("wish-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.activeItem)
      ? (_openBlock(), _createBlock(_component_item_description_overlay, {
          key: 0,
          item: _ctx.activeItem,
          onExit: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeItemId = ''))
        }, null, 8, ["item"]))
      : _createCommentVNode("", true),
    (_ctx.showDetails)
      ? (_openBlock(), _createBlock(_component_banner_details_screen, {
          key: 1,
          banner: _ctx.banner,
          onExit: _ctx.exitDetailsScreen
        }, null, 8, ["banner", "onExit"]))
      : _createCommentVNode("", true),
    (_ctx.showHistory)
      ? (_openBlock(), _createBlock(_component_wish_history_screen, {
          key: 2,
          inventory: _ctx.inventory,
          "active-banner-storage": _ctx.banner.storage,
          onExit: _ctx.exitHistoryScreen
        }, null, 8, ["inventory", "active-banner-storage", "onExit"]))
      : _createCommentVNode("", true),
    (_ctx.showSettings)
      ? (_openBlock(), _createBlock(_component_settings_screen, {
          key: 3,
          onExit: _ctx.exitSettingsScreen
        }, null, 8, ["onExit"]))
      : _createCommentVNode("", true),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isMobile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.banners, (ban, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                (
            ban.id !== 'everything' || _ctx.$store.state.settings.everythingBanner
          )
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("img", {
                        ref_for: true,
                        ref: "prefetch",
                        src: _ctx.getBannerHeaderImage(ban, true),
                        class: _normalizeClass([
              'header-resizable',
              { invisible: _ctx.currentBannerIndex !== index },
            ])
                      }, null, 10, _hoisted_5),
                      _createElementVNode("img", {
                        ref_for: true,
                        ref: "prefetch",
                        src: _ctx.getBannerHeaderImage(ban),
                        class: _normalizeClass([
              'header-resizable',
              { invisible: _ctx.currentBannerIndex === index },
            ]),
                        onClick: ($event: any) => (_ctx.changeBanner(index))
                      }, null, 10, _hoisted_6)
                    ], 64))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass({
        banner: true,
        invisible: _ctx.showDetails || _ctx.showHistory,
      })
      }, [
        _createElementVNode("div", {
          id: "header",
          class: _normalizeClass([
          'space-between',
          'center',
          _ctx.stateExiting ? 'exit-animation' : 'start-animation',
        ]),
          onAnimationend: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.exitEmit && _ctx.exitEmit(...args)))
        }, [
          _createElementVNode("div", _hoisted_7, [
            (!_ctx.isMobile)
              ? (_openBlock(), _createElementBlock("img", _hoisted_8))
              : _createCommentVNode("", true),
            _hoisted_9
          ]),
          (!_ctx.isMobile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.banners, (ban, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    (
                !(ban.id === 'everything') ||
                _ctx.$store.state.settings.everythingBanner
              )
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("img", {
                            ref_for: true,
                            ref: "prefetch",
                            src: _ctx.getBannerHeaderImage(ban, true),
                            class: _normalizeClass([
                  'header-resizable',
                  { invisible: _ctx.currentBannerIndex !== index },
                ])
                          }, null, 10, _hoisted_11),
                          _createElementVNode("img", {
                            ref_for: true,
                            ref: "prefetch",
                            src: _ctx.getBannerHeaderImage(ban),
                            class: _normalizeClass([
                  'header-resizable',
                  { invisible: _ctx.currentBannerIndex === index },
                ]),
                            onClick: ($event: any) => (_ctx.changeBanner(index))
                          }, null, 10, _hoisted_12)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_13, [
            (_ctx.isMobile)
              ? (_openBlock(), _createBlock(_component_gem_counter, {
                  key: 0,
                  icon: "starglitter.webp",
                  text: _ctx.inventory.starglitter,
                  onImageClicked: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeItemId = 'starglitter'))
                }, null, 8, ["text"]))
              : _createCommentVNode("", true),
            (_ctx.isMobile)
              ? (_openBlock(), _createBlock(_component_gem_counter, {
                  key: 1,
                  icon: "stardust.webp",
                  text: _ctx.inventory.stardust,
                  onImageClicked: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeItemId = 'stardust'))
                }, null, 8, ["text"]))
              : _createCommentVNode("", true),
            _createVNode(_component_gem_counter, {
              icon: "primogem.webp",
              text: _ctx.settings.infinitePrimos ? '∞' : _ctx.inventory.primos,
              "plus-sign": "",
              onImageClicked: _cache[3] || (_cache[3] = ($event: any) => (_ctx.activeItemId = 'primogem'))
            }, null, 8, ["text"]),
            (_ctx.banner.storage === 'standard')
              ? (_openBlock(), _createBlock(_component_gem_counter, {
                  key: 2,
                  icon: "acquaint-fate.webp",
                  text: _ctx.settings.infinitePrimos ? '∞' : _ctx.inventory.standardFates,
                  onImageClicked: _cache[4] || (_cache[4] = ($event: any) => (_ctx.activeItemId = 'acquaint-fate'))
                }, null, 8, ["text"]))
              : (_openBlock(), _createBlock(_component_gem_counter, {
                  key: 3,
                  icon: "intertwined-fate.webp",
                  text: _ctx.settings.infinitePrimos ? '∞' : _ctx.inventory.fates,
                  onImageClicked: _cache[5] || (_cache[5] = ($event: any) => (_ctx.activeItemId = 'intertwined-fate'))
                }, null, 8, ["text"])),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_close_button, { onClicked: _ctx.exit }, null, 8, ["onClicked"])
            ])
          ])
        ], 34),
        (_openBlock(), _createElementBlock("div", {
          id: "div-banner",
          key: _ctx.currentBannerIndex,
          class: _normalizeClass(_ctx.stateExiting ? 'exit-animation' : 'start-animation')
        }, [
          (_ctx.banner.id === 'everything')
            ? (_openBlock(), _createElementBlock("p", _hoisted_15, " Everyone is here! "))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.banners, (b, index) => {
            return (_openBlock(), _createElementBlock("img", {
              id: "banner",
              key: index,
              src: require(`@/assets/images/banners/${b.id}.webp`),
              class: _normalizeClass({ invisible: b.id !== _ctx.banner.id }),
              rel: "prefetch"
            }, null, 10, _hoisted_16))
          }), 128))
        ], 2)),
        _createElementVNode("div", {
          id: "footer",
          class: _normalizeClass([
          'space-between',
          _ctx.stateExiting ? 'exit-animation' : 'start-animation',
        ])
        }, [
          _createElementVNode("div", _hoisted_17, [
            (!_ctx.isMobile)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createVNode(_component_gem_counter, {
                    icon: "starglitter.webp",
                    text: _ctx.inventory.starglitter,
                    nobackground: "",
                    onImageClicked: _cache[7] || (_cache[7] = ($event: any) => (_ctx.activeItemId = 'starglitter'))
                  }, null, 8, ["text"]),
                  _createVNode(_component_gem_counter, {
                    icon: "stardust.webp",
                    text: _ctx.inventory.stardust,
                    nobackground: "",
                    onImageClicked: _cache[8] || (_cache[8] = ($event: any) => (_ctx.activeItemId = 'stardust'))
                  }, null, 8, ["text"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_text_button, {
                text: "Shop",
                onClicked: _cache[9] || (_cache[9] = ($event: any) => (_ctx.targetExitEmit = 'go-shop'))
              }),
              _createVNode(_component_text_button, {
                text: "Details",
                onClicked: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showDetails = true))
              }),
              _createVNode(_component_text_button, {
                text: "History",
                onClicked: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showHistory = true))
              }),
              _createVNode(_component_text_button, {
                text: "Settings",
                onClicked: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showSettings = true))
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_wish_button, {
              wishes: 1,
              fates: 
              _ctx.banner.storage === 'standard'
                ? _ctx.inventory.standardFates
                : _ctx.inventory.fates
            ,
              standard: _ctx.banner.storage === 'standard',
              onTryWish: _cache[13] || (_cache[13] = ($event: any) => (_ctx.wish(1)))
            }, null, 8, ["fates", "standard"]),
            _createVNode(_component_wish_button, {
              wishes: 10,
              fates: 
              _ctx.banner.storage === 'standard'
                ? _ctx.inventory.standardFates
                : _ctx.inventory.fates
            ,
              standard: _ctx.banner.storage === 'standard',
              onTryWish: _cache[14] || (_cache[14] = ($event: any) => (_ctx.wish(10)))
            }, null, 8, ["fates", "standard"])
          ])
        ], 2)
      ], 2)
    ])
  ], 64))
}